import React, { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";

import CustomButton from "Components/Commons/CustomButton/CustomButton";

import { subjectsArray } from "./subscriptionUtil";
import { Api, URL_SCHOOL_REGISTER } from "Helpers";
import { SubscriptionSummaryWrapper } from "./SubscriptionDetails.style";
import { UserSubscriptionValueContext } from "./SubscriptionDetails";

const SubscriptionSummary = (props) => {
    const { setCurrentStep, subscriptionPlanDetails, schoolId, isAlreadyRegisteredSchool } = useContext(UserSubscriptionValueContext);
    const SubjectNames = subjectsArray.filter((data) => subscriptionPlanDetails?.selectedSubjects?.includes(data?.subjectId))?.map((item) => item?.subject);

    const [paymentLoading, setPaymentLoading] = useState(false);

    const navigate = useNavigate();

    const handleBackButton = () => {
        setCurrentStep(2);
    };

    const handleNextButton = async () => {
        setPaymentLoading(true);

        const data = {
            schoolId: schoolId,
            planType: subscriptionPlanDetails?.planName,
            subType: subscriptionPlanDetails?.subTypeName?.replace("- ", ""),
            subjectNames: SubjectNames,
            isAlreadyRegisteredSchool: isAlreadyRegisteredSchool,
        };

        const response = await new Api().post("stripe/check-out/form", { data: data });

        if (response?.status === 200) {
            localStorage.setItem("subscription", JSON.stringify(data));
            if (response?.data) {
                window.location.href = response?.data;
            }
        }

        // setPaymentLoading(false);
    };

    const handleRegisterButton = async () => {
        const data = {
            schoolId: schoolId || "",
            planType: subscriptionPlanDetails?.planName,
            subType: subscriptionPlanDetails?.subTypeName?.replace("- ", ""),
            subjectNames: SubjectNames,
        };

        navigate(URL_SCHOOL_REGISTER, { state: { subscriptionRequestDto: data } });
    };

    return (
        <SubscriptionSummaryWrapper>
            <div className="subject_selection_details">
                <div className="summary-containers mygrid-container">
                    {paymentLoading ? (
                        <>
                            <div className="status-board">
                                <div className="text-one">You will be redirected to the payment gateway in a few moments...</div>
                            </div>
                        </>
                    ) : (
                        <>
                            <div className="header">
                                <div className="flex-header bck_btn_summary">
                                    <button className="back_boxed" onClick={handleBackButton}>
                                        Back
                                    </button>
                                    <h4 className="redfont">Subscription Summary</h4>
                                </div>


                                {/* <div className="flex-header">
								<div
									className={` ${!schoolId ? "registerAsSchoolFont" : "font"}`}
									onClick={!schoolId ? handleRegisterButton : handleNextButton}
								>
									{`${!schoolId ? "Register as a School" : "Next"}`}
								</div>

								<div className={`direction-button`} onClick={!schoolId ? handleRegisterButton : handleNextButton}></div>
							</div> */}
                            </div>

                            <div className="selected_plan_more_details">
                                <div className="mygrid-container">
                                    <div className="selected_plan_more-row">
                                        <div className="paln_more_item_details">
                                            <div className="redfont">Your Selection: <span>{subscriptionPlanDetails?.planTitle}</span></div>
                                        </div>
                                        <div className="paln_more_item_details">
                                            <div className="redfont">Sub Plan: <span>{subscriptionPlanDetails?.subTypeName}</span></div>
                                        </div>
                                        <div className="paln_more_item_details">
                                            <div className="redfont">Price: <span>{subscriptionPlanDetails?.price}</span></div>
                                        </div>
                                        <div className="paln_more_item_details">
                                            <div className="redfont">Subjects: <span>{SubjectNames.join(" | ")}</span></div>
                                        </div>
                                    </div>
                                    <div className="register_now_selected_plan">
                                        <CustomButton
                                            className="subscription_details_regi-button"
                                            href=""
                                            text="Register Now"
                                            onClick={!schoolId ? handleRegisterButton : handleNextButton}
                                        />
                                    </div>
                                </div>
                            </div>

                            {/* <div className="selected-subjects">
							{subjectsArray
								?.filter((sub) => subscriptionPlanDetails?.selectedSubjects?.includes(sub?.subjectId))
								?.map((data) => {
									return <SelectedSubjectWrapper key={data?.subjectId} subjectImage={data?.subjectImage} />;
								})}
						</div> */}
                        </>
                    )}
                </div>
            </div>
        </SubscriptionSummaryWrapper>
    );
};

export default SubscriptionSummary;